/**
 * 数据源选择：登录态(有 token 且 mode=cloud)走云端，否则走本地。
 */
import { useAuthStore } from '../store/auth';
import { cloudDataSource } from './cloud';
import { localDataSource } from './local';
import type { DataSource } from './types';

export function getDataSource(): DataSource {
  const { mode, accessToken } = useAuthStore.getState();
  return mode === 'cloud' && accessToken ? cloudDataSource : localDataSource;
}

export type { DataSource } from './types';
export { requestPersistentStorage } from './idb';
